// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getStorage } from '../utils/functions/localstorage';
// Define a service using a base URL and expected endpoints
const baseQuery = fetchBaseQuery({
  baseUrl: `${process.env.REACT_APP_API_URL_admin}/matchstatement/get-match-report`,
  prepareHeaders: (headers) => {
    const token = getStorage('token');
    if (token) {
      headers.set('authorization', `Bearer ${token}`);
    }
    return headers;
  },
});
export const reportMatchApi = createApi({
  reducerPath: 'reportMatchApi',
  baseQuery,
  endpoints: (builder) => ({
    reportMatch: builder.query({
      query: (q) => {
        const params = new URLSearchParams({
          sorgcode: q.sorgcode,
          amount: q.amount,
          page: String(q.page),
          size: String(q.size),
          search: q.search,
          bankName: q.bankName,
          statementDateFrom: q.statementDateFrom,
          statementDateTo: q.statementDateTo,
          sortBy: q.sortBy || 'statement_date',
          sortOrder: q.sortOrder || 'desc',
        });

        return `/?${params.toString()}`;
      },
    }),
  }),
});
export const {
  useReportMatchQuery,
} = reportMatchApi;
